/** Shared checkout line layout. Title keeps a real min width so names never wrap letter-by-letter. */
export const CHECKOUT_LINE_GRID_COLUMNS =
  '60px minmax(10rem, 2fr) minmax(0, 6.25rem) minmax(0, 6.25rem) minmax(0, 9.5rem) minmax(4.5rem, 6.25rem) minmax(0, 6.25rem) minmax(0, 6.25rem) minmax(0, 5rem)'
